import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=db511bf2&"
import script from "./Ratings.vue?vue&type=script&lang=js&"
export * from "./Ratings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db511bf2')) {
      api.createRecord('db511bf2', component.options)
    } else {
      api.reload('db511bf2', component.options)
    }
    module.hot.accept("./Ratings.vue?vue&type=template&id=db511bf2&", function () {
      api.rerender('db511bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Ratings.vue"
export default component.exports